<template>
    <div>
        <app-header :module-navigation="navigation" module-name="Campaign"></app-header>
        <main id="page-main" class="with-tabs">
            <router-view></router-view>
        </main>
    </div>
</template>
<script>

    export default {
        name: 'Campaign',
        data () {
            return {
              navigation: [
                {
                  route: 'campaign-dashboard',
                  label: 'Dashboard',
                  acl: null
                },
                {
                  route: 'audience',
                  label: 'Audience',
                  acl: null
                },
                {
                  route: 'campaign',
                  label: 'Campagnes',
                  acl: 'weeboxcore.campaign.vue'
                },
                  /*
                {
                  route: 'template',
                  label: 'Templates',
                  acl: 'weeboxcore.campaign.vue'
                },
                   */
              ]
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/campaign/Index.vue